export default __webpack_public_path__ + "static/media/img-corevalue-header.68a31b0e.jpg";